/**
 * Set up routing for all Scene views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

// import global components
import AuthoringLayout from '../admin/components/AuthoringLayout.js.jsx';
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import scene views
import AdminSceneList from './views/AdminSceneList.js.jsx';
import AdminSingleScene from './views/AdminSingleScene.js.jsx';
import AdminCreateScene from './views/AdminCreateScene.js.jsx';
import AdminUpdateScene from './views/AdminUpdateScene.js.jsx';

class SceneAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleSceneUpdatePath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update'), 0);
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display:'All scenes', path:null}]}
          component={AdminSceneList}
          exact
          role="admin"
          path="/admin/authoring/scenes"
        />
        <YTRoute
          breadcrumbs={[{display:'All scenes', path:'/admin/authoring/scenes'}, {display:'New scene', path:null}]}
          component={AdminCreateScene}
          exact
          role="admin"
          path="/admin/authoring/scenes/new"
        />
        <YTRoute
          breadcrumbs={[{display:'All scenes', path:'/admin/authoring/scenes'}, {display:'Scene details', path:null}]}
          component={AdminSingleScene}
          exact
          role="admin"
          path="/admin/authoring/scenes/:sceneId"
        />
        <YTRoute
          breadcrumbs={[{display:'All scenes', path:'/admin/authoring/scenes'}, {display:'Scene details', path:singleSceneUpdatePath}, {display:'Update', path:null}]}
          component={AdminUpdateScene}
          exact
          role="admin"
          path="/admin/authoring/scenes/:sceneId/update"
        />
      </Switch>
    )
  }
}

export default withRouter(SceneAdminRouter);



// WEBPACK FOOTER //
// modules/scene/SceneAdminRouter.js.jsx